import type { PanelProps } from "../panel-props"

import { IS_AUTH } from "../../../modules/auth"
import { useSettings } from "../../../modules/settings"
import { Select } from "../../select"
import { SharedSettings } from "../shared-settings"

const WORDS_PER_SET_OPTIONS = [
  { key: "1", label: "1" },
  { key: "2", label: "2" },
  { key: "3", label: "3" },
  { key: "4", label: "4" },
]

const SOURCE_OPTIONS = [
  { key: "bookmarks", label: "bookmarks" },
  { key: "core bookmarks", label: "core bookmarks" },
  { key: "pair of word", label: "pair of word" },
]

export function RememberSequenceSettings({ closeSidebar }: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()

  const onChangeWordsPerSet = (value: string)=> {
    setAppSettings("wordsPerSet", Number(value), "rememberSequence")
  }

  const onChangeSource = (value: string)=> {
    setAppSettings("source", value, "rememberSequence")
  }

  return (
    <SharedSettings closeSidebar={closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Setup</h3>
        {IS_AUTH && (
          <Select
            initialValue={appSettings.rememberSequence.source}
            label="Source"
            onChange={onChangeSource}
            options={SOURCE_OPTIONS}
          />
        )}
        <Select
          initialValue={String(appSettings.rememberSequence.wordsPerSet)}
          label="Words per set"
          onChange={onChangeWordsPerSet}
          options={WORDS_PER_SET_OPTIONS}
        />
      </section>
    </SharedSettings>
  )
}
